import { render } from "./App.vue?vue&type=template&id=46c5f291"
const script = {}

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e608e564589b97f0695ff94baa79f4b4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__